import React from 'react'

import { useTranslation } from '../../contexts/I18nContext'

import Styled from './RecipeFeedbackForm.styled'

const RecipeFeedbackForm = ({
  author,
  canSubmit,
  className,
  imageUrl,
  onSubmit,
  options,
  setValue,
  source,
  title,
  value,
}) => {
  const { t } = useTranslation()
  const isUserGenerated = source === 'user-generated'
  return (
    <Styled className={className}>
      <Styled.title>{t('ORDER.FEEDBACK_TITLE')}</Styled.title>
      <Styled.thumbnail isUserGenerated={isUserGenerated}>
        <img src={imageUrl} alt={title} />
      </Styled.thumbnail>
      {isUserGenerated && author?.name ? (
        <Styled.author>
          <Styled.authorLabel>
            {t('ORDER.FEEDBACK_RECIPE_AUTHOR')}
          </Styled.authorLabel>
          <Styled.authorAvatar
            name={author?.name}
            imageUrl={author?.imageUrl}
          />
        </Styled.author>
      ) : null}
      <Styled.subtitle>{t('ORDER.FEEDBACK_RECIPE', title)}</Styled.subtitle>
      <Styled.stars
        value={value.n_rating}
        setValue={(n) => setValue({ n_rating: n })}
      />
      <Styled.separator />
      {options.length > 0 ? (
        <Styled.options>
          <Styled.subtitle>
            {t('ORDER.FEEDBACK_RECIPE_OPTIONS')}
          </Styled.subtitle>
          {options.map(({ id, text }) => (
            <Styled.option
              key={id}
              id={id}
              label={text}
              value={
                (value.options || []).find((option) => option.id === id)?.value
              }
              setValue={(v) =>
                setValue({
                  options: value.options
                    .filter((option) => option.id !== id)
                    .concat({ id, text, value: v }),
                })
              }
            />
          ))}
        </Styled.options>
      ) : null}
      <Styled.separator />
      <Styled.subtitle>{t('ORDER.FEEDBACK_RECIPE_COMMENT')}</Styled.subtitle>
      <Styled.textArea
        rows={5}
        placeholder={t('ORDER.FEEDBACK_RECIPE_COMMENT_PLACEHOLDER')}
        value={value.comments}
        onChange={(event) => setValue({ comments: event.target.value })}
      />

      <Styled.footer>
        <Styled.submit onClick={onSubmit} disabled={!canSubmit}>
          {t('CONFIRM')}
        </Styled.submit>
      </Styled.footer>
    </Styled>
  )
}

RecipeFeedbackForm.defaultProps = {
  value: {},
}

export default RecipeFeedbackForm
